import { supabase } from '@/shared/lib/supabase';
import type { MusicaRaioX } from '@/shared/types';

interface RespostaRaioX {
  ok:     boolean;
  raiox?: MusicaRaioX;
  erro?:  string;
}

export const raioXRepository = {

  /**
   * Busca o raio-x de um vídeo. A Edge Function resolve cache e provedores;
   * aqui só devolvemos o que veio. `null` cobre falha de rede, function fora
   * do ar e resposta inválida — todos tratados como "sem raio-x", nunca erro
   * na TV.
   */
  async obterRaioX(
    videoId: string,
    titulo:  string,
    canal:   string | null,
  ): Promise<MusicaRaioX | null> {
    try {
      const { data, error } = await supabase.functions.invoke('musica-raiox', {
        body: { video_id: videoId, titulo, canal },
      });
      if (error) return null;
      const resp = data as RespostaRaioX;
      return resp?.ok && resp.raiox ? resp.raiox : null;
    } catch {
      return null;
    }
  },
};
